// pages/FormViewerPage/components/VariantOptions/DropdownOption.tsx — Dropdown style variant
import React from 'react';
import type { Form } from '../../../../types';
import { formatMoney } from '../../../../utils/formatMoney';
import { singleLockGroup } from '../../../../utils/regionPricing';
import type { ProductOption, VariantCombination } from './types';

export const DropdownOption: React.FC<{
    option: ProductOption;
    selectedOptions: Record<string, string>;
    onOptionChange: (name: string, value: string) => void;
    getVariantDetails: (name: string, val: string) => VariantCombination | null;
    form?: Form;
    hasError?: boolean;
}> = ({ option, selectedOptions, onOptionChange, getVariantDetails, form, hasError }) => (
    <select
        onChange={(e) => onOptionChange(option.name, e.target.value)}
        value={selectedOptions[option.name] || ''}
        className={`w-full p-3 border rounded-lg bg-slate-50 dark:bg-slate-700 dark:border-slate-500 font-medium ${hasError ? 'border-red-400 ring-1 ring-red-300' : ''}`}
    >
        <option value="">— Pilih {option.name} —</option>
        {option.values.map(val => {
            const details = getVariantDetails(option.name, val);
            const isDefault = form?.defaultVariant === val;
            const strikeTag = option.showPrice !== false && details?.strikethroughPrice != null && details?.sellingPrice != null && details.strikethroughPrice > details.sellingPrice
                ? ` (coret ${formatMoney(details.strikethroughPrice, form)})`
                : '';
            const priceTag = option.showPrice !== false && (!(form?.productRegionGroups?.length) || singleLockGroup(form)) && details?.sellingPrice != null
                ? ` - ${formatMoney(details.sellingPrice, form)}${strikeTag}`
                : '';
            const label = `${val}${priceTag}${isDefault ? ' ⭐ (Rekomendasi)' : ''}`;
            return <option key={val} value={val}>{label}</option>;
        })}
    </select>
);
